import React from "react";
import clsx from "clsx";

import Line from "components/Charts/Line";
import { isExpirationWarning } from "../helper";
import ExpirationDays from "../ExpirationDays";

import useStyles from "./styles";

interface IProps {
  horseName: string;
  examType: string;
  reactivationDays: number;
}

const MobileExpiringExamRequirement = (props: IProps) => {
  const { examType, horseName, reactivationDays } = props;

  const classes = useStyles();

  const isHighAttention = isExpirationWarning(reactivationDays);

  return (
    <div className={classes.mobileRoot}>
      <div className={classes.mobileInfoRow}>
        <div className={clsx(classes.horseName, classes.mobileCell)}>
          {horseName}
        </div>
        <div className={classes.mobileCell}>{examType}</div>
        <div className={classes.mobileCell}>Days Until Expiration</div>
        <ExpirationDays reactivationDays={reactivationDays} />
      </div>
      <Line
        value={reactivationDays}
        capacity={14}
        className={isHighAttention && classes.highAttention}
      />
    </div>
  );
};

export default React.memo(MobileExpiringExamRequirement);
